import { OrderStatusesTypes } from "@/types/statuses.types"
import { Switch } from "antd"
import { useTranslation } from "react-i18next"
import React from "react"
import { useFlags } from "flagsmith/react"
import { userAtom } from "@/atoms/userAtom"
import { useRecoilValue } from "recoil"

interface StatusNotificationRowProps {
  active: boolean
  status: OrderStatusesTypes
  onChange: (status: OrderStatusesTypes, value: boolean) => void
  isLoading: boolean
  disabled?: boolean
}

const StatusNotificationRow: React.FC<StatusNotificationRowProps> = ({
  active,
  status,
  onChange,
  isLoading,
  disabled,
}) => {
  const { t } = useTranslation()
  const { preference } = useRecoilValue(userAtom)
  const { branding } = preference
  const isPreviewAvailable = !!branding?.companyLogoUrl && !!branding?.companyName
  const { height = 42, width = 42 } = branding?.width ? branding : { height: 42, width: 42 }
  const trackingPreviewQueryParams = isPreviewAvailable
    ? `&companyName=${branding?.companyName}&companyLogoUrl=${
        branding?.companyLogoUrl
      }&primaryColor=${
        branding?.primaryColor ? branding?.primaryColor?.replace("#", "") : ""
      }&secondaryColor=${
        branding?.secondaryColor ? branding?.secondaryColor?.replace("#", "") : ""
      }&companyWebsiteUrl=${branding?.companyWebsiteUrl}&logoAspectRatio=${height / width}`
    : ""
  const flags = useFlags(["nash_branding"])
  return (
    <div className="grid grid-cols-12 gap-y-2">
      <div className="col-span-2 sm:col-span-1 md:col-span-1 lg:col-span-1 xl:col-span-1 2xl:col-span-1">
        <Switch
          checked={active}
          onChange={(value) => onChange(status, value)}
          loading={isLoading}
          disabled={disabled}
        />
      </div>
      <div className="col-span-10 sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-2 2xl:col-span-2">
        <p className="font-semibold">{t(`common.order-status.${status}.status`)}</p>
      </div>
      <div className="col-span-12 sm:col-span-8 md:col-span-8 lg:col-span-8 xl:col-span-8 2xl:col-span-8">
        <p>{t(`common.order-status.${status}.description`)}</p>
      </div>
      <div className="col-span-12 sm:col-span-1 md:col-span-1 lg:col-span-1 xl:col-span-1 2xl:col-span-1">
        <a
          href={`${process.env.NEXT_PUBLIC_TRACKING_HOST}/demo?status=${status}${trackingPreviewQueryParams}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <p
            className={`break-all cursor-pointer font-color text-${
              flags.nash_branding.enabled ? "nashPrimaryGreen" : "kosmoPrimaryBlue"
            }`}
          >
            {t("common.preview")}
          </p>
        </a>
      </div>
    </div>
  )
}

export default StatusNotificationRow
